import type { ApiRole } from '@izimi/api';

export const getUserRole = (roles: ApiRole[] | ApiRole) => {
  const role = Array.isArray(roles) ? roles[0] : roles;
  return role;
};

export const isUserRole = (role: ApiRole, roles: ApiRole[] | ApiRole) => {
  if (roles == null || (Array.isArray(roles) && roles.length === 0)) {
    return false;
  }
  const userRole = getUserRole(roles);
  return userRole === role;
};
